export default __webpack_public_path__ + "static/media/img-left-spark-founders-club-2.26614b36.jpg";